<template>
    <v-card style="width: 100%;">
        <v-card-title>{{this.$t('simulacion.modulo.electrolizador.titulo')}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-row>
            <v-col cols="12">
                
                <v-container>
                    <!--
                    <v-form v-model="valid" lazy-validation>
                    <v-row>
                        <v-col v-for="(value, key) in datos" :key="key" cols="12" sm="3">
                        <v-text-field v-if="!campos_ocultos.includes(key)"
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel(key)"
                            v-model.number="datos[key]"
                            :type="getFieldType(key)"                            
                            :hint="getHint(key)"
                            @input="updateValue" 
                        ></v-text-field>
                        </v-col>
                    </v-row>
                    </v-form>
                    -->

                    <v-row>
                      <v-col cols="3" sm="3">
                        <v-typography variant="h1">
                          {{ $t('simulacion.modulo.electrolizador.datos_operativos') }}
                        </v-typography>                                              
                      </v-col>
                    </v-row>
                  <v-row>
                    <v-col cols="3" sm="3">
                      <v-text-field
                        :disabled="this.disabled"
                        density="compact"
                        rounded="sm"
                        variant="outlined"
                        :label="formatLabel('pmin')"
                        :model-value="pmin"
                        @update:modelValue="val => pmin = val"
                        
                        :hint="getHint('pmin')"
                        @input="updateValue"
                        :rules="[rules.Negativo]"
                      ></v-text-field>
                    </v-col>
                    <!-- Por retrocompatibilidad -->
                    <v-col cols="3" sm="3" v-if="!(degradacionElectrolizador.length>0)">
                      <v-text-field
                      :disabled="this.disabled"
                        density="compact"
                        rounded="sm"
                        variant="outlined"
                        :label="formatLabel('degrad')"
                        :model-value="degrad"
                        @update:modelValue="val => degrad = val"
                        
                        :hint="getHint('degrad')"
                        @input="updateValue"
                        :rules="[rules.Negativo]"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="3" sm="3">
                      <v-text-field
                      :disabled="this.disabled"
                        density="compact"
                        rounded="sm"
                        variant="outlined"
                        :label="formatLabel('cnag')"
                        :model-value="formatNumber(datos.cnag)"
                        @update:modelValue="val => datos.cnag = Number(val.replace(',', '.'))"
                        
                        :hint="getHint('cnag')"
                        @input="updateValue"
                        :rules="[rules.Negativo]"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="3" sm="3">
                      <v-text-field
                      :disabled="this.disabled"
                        density="compact"
                        rounded="sm"
                        variant="outlined"
                        :label="formatLabel('pcag')"
                        :model-value="formatNumber(datos.pcag)"
                        @update:modelValue="val => datos.pcag = Number(val.replace(',', '.'))"
                        
                        :hint="getHint('pcag')"
                        @input="updateValue"
                        :rules="[rules.Negativo]"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="3" sm="3">
                      <v-text-field
                      :disabled="this.disabled"
                        density="compact"
                        rounded="sm"
                        variant="outlined"
                        :label="formatLabel('cagmax')"
                        :model-value="formatNumber(local_gen.cagmax)"
                         @update:modelValue="val =>  local_gen.cagmax = Number(val.replace(',', '.'))"
                        :hint="getHint('cagmax')"
                        @input="updateValue"
                        :rules="[rules.Negativo]"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="3" sm="3">
                      <v-text-field
                      :disabled="this.disabled"
                        density="compact"
                        rounded="sm"
                        variant="outlined"
                        :label="formatLabel('vutil')"
                        :model-value="formatNumber(datos.vutil)"
                        @update:modelValue="val => datos.vutil = Number(val.replace(',', '.'))"
                        
                        :hint="getHint('vutil')"
                        @input="updateValue"
                        :rules="[rules.Negativo]"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                 

                    <v-row>
                      <v-col cols="3" sm="3">
                        <v-typography variant="h1">
                          {{ $t('simulacion.modulo.electrolizador.datos_economicos') }}
                        </v-typography>                                              
                      </v-col>
                    </v-row>

                    <!--
                    <v-row>


                      <v-col cols="3" sm="3">
                      

                        <v-text-field
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel('capexf')"
                            v-model.number="datos['capexf']"
                            type="number"                            
                            :hint="getHint('capexf')"
                            @input="updateValue" 
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" sm="3">
                        <v-text-field
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel('capexv')"
                            v-model.number="datos['capexv']"
                            type="number"                            
                            :hint="getHint('capexv')"
                            @input="updateValue" 
                        ></v-text-field>
                      </v-col>

                      <v-col cols="3" sm="3">
                        <v-text-field
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel('capexvb')"
                            v-model.number="datos['capexvb']"
                            type="number"                            
                            :hint="getHint('capexvb')"
                            @input="updateValue" 
                        ></v-text-field>

                      </v-col>


                    </v-row>


                    <v-row>
                      <v-col cols="3" sm="3">
                        <v-text-field
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel('opex')"
                            v-model.number="opex"
                            type="number"                            
                            :hint="getHint('opex')"
                            @input="updateValue" 
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" sm="3">
                        <v-text-field
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel('capexr')"
                            v-model.number="datos['capexr']"
                            type="number"                            
                            :hint="getHint('capexr')"
                            @input="updateValue" 
                        ></v-text-field>
                      </v-col>






                    </v-row>
                    -->
                    <v-row>
                    <v-col cols="6" sm="6">
                      <v-switch
                      :readonly="this.disabled"
                      :class="{ 'switch-disabled-look': this.disabled }"
                        v-model="usarCurvasBOP"
                        :label="$t('simulacion.modulo.curvas_CAPEXOPEX.capex_opex_curvas')"
                        inset
                        hide-details
                        color="blue"         
                        track-color="grey"
                      />
                    </v-col>
                    <v-col cols="6" sm="6">
                      <v-switch
                      :readonly="this.disabled"
                      :class="{ 'switch-disabled-look': this.disabled }"
                      v-if="!usarCurvasBOP"
                      
                        v-model="usarOpexAnual"
                        :label="$t('simulacion.modulo.curvas_CAPEXOPEX.opex_anual') "
                        inset
                        hide-details
                        color="blue"         
                        track-color="grey"
                      />
                    </v-col>
                  </v-row>
                    <v-row>
                      <v-col cols="3" sm="3" v-if="!usarCurvasBOP">
                        <ComponenteEditorCAPEXOPEX 
                        :disabled="this.disabled"
                        :titulo="$t('simulacion.modulo.electrolizador.capex')"
                        v-model:valorVariable="datos.capexv"
                        v-model:valorFijo="datos.capexf"
                        unidad-variable="kEUR/MW"
                        unidad-fijo="kEUR"
                        />
                      </v-col>


                      <v-col cols="3" sm="3" v-if="!usarCurvasBOP && !usarOpexAnual">
                        <ComponenteEditorCAPEXOPEX 
                        :disabled="this.disabled"
                        :titulo="$t('simulacion.modulo.electrolizador.opex')"
                        v-model:valorVariable="datos.opexv"
                        v-model:valorFijo="datos.opexf"
                        unidad-variable="kEUR/MW año"
                        unidad-fijo="kEUR año"
                        />
                      </v-col>
                      <v-col cols="3" sm="3"><br><br>
                   
                      <v-text-field
                      :disabled="this.disabled"
                        density="compact"
                        rounded="sm"
                        variant="outlined"
                        :label="$t('simulacion.modulo.electrolizador.reemplazo')"
                        v-model.number="datos['capexr']"
                        type="number"
                        :hint="getHint('capexr')"
                        @input="updateValue"
                        :rules="[rules.Negativo]"
                      ></v-text-field>
                    </v-col>
                      
                    </v-row>    
                    <v-row>
                      <v-col cols="12">
                      
                      <div v-if="!usarCurvasBOP && usarOpexAnual">
                        <ComponenteInputMatrizAnual
                        :disabled="this.disabled"
                        title="Opex Anual"
                        :modelValue="this.electrolizador.senda_opex"
                        :years="this.years"
                        nombre_tabla="OPEX"
                        :nombres_fila="['Fijo','Variable']"
                        :nombres_tabla="{
                          'fijo':$t('simulacion.modulo.curvas_CAPEXOPEX.fijo_units'),
                          'variable':$t('simulacion.modulo.curvas_CAPEXOPEX.variable_units'),
                        }"
                         @update:modelValue="this.$emit('update:electrolizador', {
                                                ...this.electrolizador,
                                                senda_opex: $event
                                              });"
                        />

                       
                      </div>
                       </v-col>
                    </v-row>
                    

                    <!-- Por retrocompatibilidad -->
                    <v-row v-if="degradacionElectrolizador.length>0">
                      <v-col cols="12">
                        <ComponenteInputElectrolizadorDegrad
                        :disabled="this.disabled"
                          :value="degradacionElectrolizador"
                          @update:value="$emit('update:degradacionElectrolizador', $event)"
                          :desdeSim="true"
                          :HoraFinal="HoraFinal"
                          
                        />
                      </v-col>
                    </v-row>  
                    <v-row>
                      <v-col cols="12">
                        <ComponenteInputElectrolizadorRend
                        :disabled="this.disabled"
                          :value="rendimientoElectrolizador"
                          @update:value="$emit('update:rendimientoElectrolizador', $event)"
                          :desdeSim="true"
                        />
                      </v-col>
                    </v-row>             
                    

                      
                </v-container>

            </v-col>
            </v-row>
        </v-card-text>
    </v-card>



</template>

<script>
import ComponenteEditorCAPEXOPEX from '../components/ComponenteEditorCAPEXOPEX.vue';
import ComponenteInputElectrolizadorRend from '../components/ComponenteInputElectrolizadorRend.vue';
import ComponenteInputElectrolizadorDegrad from '../components/ComponenteInputElectrolizadorDegrad'
import ComponenteInputMatrizAnual from './ComponenteInputMatrizAnual.vue';
import { mask } from 'v-mask';
export default {
  directives: {
      mask,
    },  
  props: {
    disabled:{
      type:Boolean,
      default:false
    },
    electrolizador: { // Recibe el valor desde el padre
      type: Object,
      required: true,
    },
    gen: { // Recibe el valor desde el padre
      type: Object,
      required: true,
    }, 
    usarCapexOpexGeneralElectrolizador: String   ,
    electrolizadorRend: {
      type: Array,
      required: true
    },
    rendimientoElectrolizador: {
    type: Array,
    required: true
  },
  degradacionElectrolizador:{
    type: Array,
    required:true,
  },
  HoraFinal:{
    type:Number,
    required:true,

  },
  years:{
    type:Array,
    required:true
  },


  },
  data() {
    return {
      value: 0,
      valid: false,
      datos: this.electrolizador, // Inicializa los datos con el valor recibido
      local_gen: { ...this.gen},
      usarCapexOpexGeneral: this.usarCapexOpexGeneralElectrolizador || 'especifico',
      labels: {        
        pmin: this.$t('simulacion.modulo.electrolizador.pmin'),
        prend: this.$t('simulacion.modulo.electrolizador.prend'),
        //cauxmn: this.$t('simulacion.modulo.electrolizador.cauxmn'),
        //cauxmx: this.$t('simulacion.modulo.electrolizador.cauxmx'),
        cnag: this.$t('simulacion.modulo.electrolizador.cnag'),
        rdag: this.$t('simulacion.modulo.electrolizador.rdag'),
        pcag: this.$t('simulacion.modulo.electrolizador.pcag'),
        hfun: this.$t('simulacion.modulo.electrolizador.hfun'),
        capexf: this.$t('simulacion.modulo.electrolizador.capexf'),
        capexv: this.$t('simulacion.modulo.electrolizador.capexv'),
        opexf: this.$t('simulacion.modulo.electrolizador.opexf'),
        opexv: this.$t('simulacion.modulo.electrolizador.opexv'),
        capexr: this.$t('simulacion.modulo.electrolizador.capexr'),
        vutil: this.$t('simulacion.modulo.electrolizador.vutil'),
        pelfija: this.$t('simulacion.modulo.electrolizador.pelfija'),
        degrad: this.$t('simulacion.modulo.electrolizador.degrad'),
        //capexvb: this.$t('simulacion.modulo.electrolizador.capexvb'),
        cagmax: this.$t('simulacion.modulo.electrolizador.cagmax'),   
      },
      campos_ocultos: ["hfun", "pelfija"],
      rules: {
        required: v => !!v || 'This field is required',
        Negativo : v => {
  if (v === null || v === undefined || v === '') return true;
  return parseFloat(v.toString().replace(',', '.')) >= 0 || 'No puede ser negativo';
}
      },
      datosRendimientoElectrolizador: [],
      datosDegradacionElectrolizador:[]


    };
  },
  components: {
    ComponenteEditorCAPEXOPEX,
    ComponenteInputElectrolizadorRend,
    ComponenteInputElectrolizadorDegrad,
    ComponenteInputMatrizAnual
  },
  computed: {
    lista_anios:{

    },

    pmin: {
      get() {
        return this.formatNumber(this.datos.pmin * 100);
      },
      set(val) {
        const parsed = Number(val.replace(',', '.')) / 100;
        this.datos.pmin = isNaN(parsed) ? 0 : parsed;
      }
    },

    degrad: {
      get() {
        return this.formatNumber(this.datos.degrad * 100);
      },
      set(val) {
        const parsed = Number(val.replace(',', '.')) / 100;
        this.datos.degrad = isNaN(parsed) ? 0 : parsed;
      }
    },

    /*cauxmn: {
      get() {        
        const value = this.datos.cauxmn
        return (value * 100).toFixed(2)               
      },
      set(value) {        
        const numericValue = value / 100;
        this.datos.cauxmn = isNaN(numericValue) ? 0 : numericValue;
      },
    },    

    cauxmx: {
      get() {        
        const value = this.datos.cauxmx
        return (value * 100).toFixed(2)               
      },
      set(value) {        
        const numericValue = value / 100;
        this.datos.cauxmx = isNaN(numericValue) ? 0 : numericValue;
      },
    }, */

    /*opex: {
      get() {        
        const value = this.datos.opex
        return (value * 100).toFixed(2)               
      },
      set(value) {        
        const numericValue = value / 100;
        this.datos.opex = isNaN(numericValue) ? 0 : numericValue;
      },
    }, */
    usarCurvasBOP: {
      get() {
        return this.datos.curvas?.capex === 1 && this.datos.curvas?.opex === 1;
      },
      set(val) {
        this.datos.curvas.capex = val ? 1 : 0;
        this.datos.curvas.opex = val ? 1 : 0;
      }
    },
    usarOpexAnual: {
      get() {
        return this.datos.opex_anual === 1 
      },
      set(val) {
        console.log("usarOpexAnual Val ", val)
        this.datos.opex_anual = val ? 1 : 0;
        console.log("this.datos.curvas.opex_anual ", this.datos.opex_anual)
      }
    }
  },
  watch: {
    // Vigila los cambios en `datos` y emite el evento cuando cambian
    datos: {
      handler(newDatos) {
        this.$emit('update:modelValue', newDatos);
      },
      deep: true, // Escucha los cambios profundos dentro de `datos`
    },

    local_gen: {
      handler(newDatos) {
        this.$emit('update:gen', newDatos);
      },
      immediate: true,
      deep: true,
    },

    '$i18n.locale'() {      
       
        this.labels.pmin = this.$t('simulacion.modulo.electrolizador.pmin')
        this.labels.prend = this.$t('simulacion.modulo.electrolizador.prend')
        //this.labels.cauxmn = this.$t('simulacion.modulo.electrolizador.cauxmn')
        //this.labels.cauxmx = this.$t('simulacion.modulo.electrolizador.cauxmx')
        this.labels.cnag = this.$t('simulacion.modulo.electrolizador.cnag')
        this.labels.rdag = this.$t('simulacion.modulo.electrolizador.rdag')
        this.labels.pcag = this.$t('simulacion.modulo.electrolizador.pcag')
        this.labels.hfun = this.$t('simulacion.modulo.electrolizador.hfun')
        this.labels.capexf = this.$t('simulacion.modulo.electrolizador.capexf')
        this.labels.capexv = this.$t('simulacion.modulo.electrolizador.capexv')
        this.labels.opex = this.$t('simulacion.modulo.electrolizador.opex')
        this.labels.capexr = this.$t('simulacion.modulo.electrolizador.capexr')
        this.labels.vutil = this.$t('simulacion.modulo.electrolizador.vutil')
        this.labels.pelfija = this.$t('simulacion.modulo.electrolizador.pelfija')
        this.labels.degrad = this.$t('simulacion.modulo.electrolizador.degrad')     
        //this.labels.capexvb = this.$t('simulacion.modulo.electrolizador.capexvb')  
        this.labels.cagmax = this.$t('simulacion.modulo.electrolizador.cagmax')  
    },
    usarCapexOpexGeneral: {
    handler() {
      this.emitirOpcionGeneral();
    }
  },
    datosRendimientoElectrolizador: {
    handler(newVal) {
      this.$emit('update:rendimientoElectrolizador', newVal);
    },
    deep: true
  },
 /*  datosDegradacionElectrolizador: {
    handler(newVal) {
      this.$emit('update:degradacionElectrolizador', newVal);
    },
    deep: true
  } */


  },
  methods: {
    formatNumber(value) {
      if (value === null || value === undefined || value === '') return '';
      if (typeof value !== 'number') value = Number(value);

      // Si es entero, no ponemos decimales
      if (Number.isInteger(value)) {
        return value.toString().replace('.', ',');
      } else {
        // Si tiene decimales, mostramos con coma
        return value.toString().replace('.', ',');
      }
    },
    formatLabel(key) {

      let out = key.charAt(0).toUpperCase() + key.slice(1)
      out = this.labels[key]
      return out;
    },
    getFieldType(key) {
      
      if (key === 'pmin' || key === 'capex' || key === 'nfijo') {
        return 'number';
      }
      return 'text';
      
    },
    getHint(key) {
      if (key === 'capex') {
        return 'In currency';
      }
      return '';
    },
    saveData() {
      console.log('Data saved:', this.datos);
    },
  },
  emitirOpcionGeneral() {
      this.$emit('update:usarCapexOpexGeneralElectrolizador', this.usarCapexOpexGeneral);
    }
};
</script>

<style scoped>
.v-btn {
  margin-top: 20px;
}


</style>
